// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2qPZP","rootSuccess":"CompleteLink_rootSuccess__1m9Wv","rootFailure":"CompleteLink_rootFailure__39AfP","isDisabled":"CompleteLink_isDisabled__95H9w"};